module.exports = __webpack_public_path__ + "img/eye-icon.30bbf080.svg";